var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NcCheckboxRadioSwitch',{attrs:{"id":"imip-create","model-value":_vm.imipCreate,"disabled":_vm.saving},on:{"update:checked":_vm.onToggleImipCreate}},[_vm._v("\n\t\t"+_vm._s(_vm.t('mail', 'Automatically create tentative appointments in calendar'))+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }